import React from "react";
import { Phone, MessageSquare } from "lucide-react";

const FloatingBar = () => {
  const phoneNumber = "917416116587";
  const message =
    "hii, i would like to enquire about safetynets from your website ";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-[#2c3639] text-white py-2 flex justify-center items-center gap-8 shadow-lg"
      style={{
        zIndex: "88421898014820",
      }}
    >
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center px-4 py-2 bg-[#a27b5c] text-white font-medium rounded hover:bg-[#a27b5c] transition-colors duration-300"
      >
        <MessageSquare size={20} />
        <span className="ml-2">WhatsApp</span>
      </a>

      {/* Phone Call Icon */}
      <a
        href={`tel:${phoneNumber}`}
        className="flex items-center px-4 py-2 bg-[#a27b5c] text-white font-medium rounded hover:bg-[#a27b5c] transition-colors duration-300"
      >
        <Phone size={20} />
        <span className="ml-2">7416116587</span>
      </a>
    </div>
  );
};

export default FloatingBar;
